export default {
  default: () => import("/root/workspace/ldshop_vest/apps/vest/layouts/default.vue")
}